export function funPermisosObtenidosBoolean(permisos = [], permiso)
{
    const find_perm = permisos.find(perm => perm.pemslug == permiso)

    if(find_perm){
        return true
    }else{
        return false
    }
}